import { FC, useCallback } from 'react';
import Iframe from 'src/components/Iframe';
import Popup from '../popup';
import { Res } from '../types';
import { ExternalProps } from './types';

const IFrameStyle = { height: '100%', width: '100%' } as CSSStyleDeclaration;
export const ExternalPopup: FC<ExternalProps & { children?: any }> = ({
  show,
  url,
  onClose,
  logo,
  width,
  height,
  iframeSettings,
  windowWidth,
  isImage = false
}) => {
  const windowSize = windowWidth && windowWidth > 468 ? 'desktop' : 'mobile';
  const resolution = iframeSettings ? iframeSettings[windowSize].sizeType : Res.Percentage;
  const popWidth = iframeSettings ? iframeSettings[windowSize].width : width;
  const popHeight = iframeSettings ? iframeSettings[windowSize].height : height;

  const renderPopupContent = useCallback(() => {
    if (isImage) {
      return <img width="100%" height="100%" src={url} />;
    } else {
      return <Iframe logoSrc={logo} title="external-popup" src={url} style={IFrameStyle} />;
    }
  }, [isImage, logo, url]);

  return (
    <Popup
      id="external-popup"
      show={show}
      onClose={onClose}
      settings={{ width: popWidth, height: popHeight, resolution }}
    >
      {renderPopupContent()}
    </Popup>
  );
};
